<template>

  <mdc-dialog v-model="isOpen"
              :title="!isEdit ? 'user.add_curator' : 'user.edit_curator' | trans"
              :accept="'user.save' | trans"
              :cancel="'user.cancel' | trans"
              :accept-disabled="disabled"
              @accept="close"
              @cancel="close"
              @validate="save">
    <div class="close-cross" @click="close()">
      <mdc-icon icon="close"></mdc-icon>
    </div>
    <loader v-if="!isLoaded" class="table-loader"></loader>
    <form enctype="multipart/form-data" novalidate>

      <div class="form-group row">
        <div class="col-md-12">
          <mdc-textfield id="username"
                         type="text"
                         :label="'validation.attributes.username' | trans"
                         name="username"
                         :class="{'is-invalid': errors.has('username') || (validationError && validationError.username)}"
                         v-validate="{required: true, max: 255, min: 5, unique_username: true, regex: /^[a-zA-Z0-9._@-]+$/}"
                         v-model="user.username"
                         autocomplete="new-username"
                         data-vv-validate-on="none"
                         :data-vv-as="'validation.attributes.username' | trans"/>

          <span class="invalid-feedback"
                v-if="validationError && validationError.username">
                        <strong>{{validationError.username.message}}</strong>
                    </span>
          <span class="invalid-feedback"
                v-if="errors.has('username') && errors.firstRule('username') != 'regex'">
                        <strong>{{ errors.first('username') }}</strong>
                    </span>

          <span class="invalid-feedback"
                v-if="errors.firstRule('username') === 'regex' ">
                        <strong>{{'validation.regex', {attribute: userName} | trans}}</strong>
                    </span>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <mdc-textfield id="displayName"
                         type="text"
                         :label="'validation.attributes.displayName' | trans"
                         name="displayName"
                         :class="{'is-invalid': errors.has('displayName')}"
                         v-validate="'required|max:255'"
                         v-model="user.displayName"
                         data-vv-validate-on="none"
                         :data-vv-as="'validation.attributes.displayName' | trans"/>
          <span class="invalid-feedback" v-if="errors.has('displayName')">
              <strong>{{ errors.first('displayName') }}</strong>
          </span>
        </div>
      </div>


      <div class="form-group row">
        <div class="col-md-12">
          <mdc-textfield id="password"
                         ref="password"
                         type="password"
                         :label="isEdit ? 'validation.attributes.new_password' : 'validation.attributes.password'| trans"
                         name="password"
                         :class="{'is-invalid': errors.has('password')}"
                         v-validate="'min:8|max:16'"
                         v-model="user.password"
                         v-bind:value="user.password"
                         v-on:input="$emit('input', $event.target.value)"
                         data-vv-validate-on="none"
                         autocomplete="new-password"
                         :data-vv-as="'validation.attributes.password' | trans"/>
          <span class="invalid-feedback"
                v-if="errors.has('password') || errors.has('form-pass.password')">
                            {{errors.first('password')  || errors.first('form-pass.password') }}
                        </span>
          <small class="form-text text-muted">
            {{'passwords.password_subscription' | trans}}
          </small>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <mdc-textfield v-model="user.passwordConfirmation"
                         :label="'validation.attributes.password_confirmation' | trans"
                         v-bind:value="user.passwordConfirmation"
                         v-on:input="$emit('input', $event.target.value)"
                         type="password" name="password_confirmation"
                         :class="{'is-invalid': errors.has('password_confirmation') || errors.has('newPasswordConfirmation') || errors.has('form-pass.password_confirmation')}"
                         v-validate="'min:8|max:16|confirmed:password'"
                         data-vv-validate-on="none"
                         :data-vv-as="'validation.attributes.password_confirmation' | trans"/>
          <span class="invalid-feedback"
                v-if="errors.has('password_confirmation') || errors.has('newPasswordConfirmation') || errors.has('form-pass.password_confirmation')">
              {{'validation.confirmed', {attribute: passwordLabel} | trans}}
          </span>
        </div>
      </div>

    </form>
  </mdc-dialog>

</template>

<script>
  import {mapActions, mapState} from 'vuex';
  import {Validator} from 'vee-validate';
  import lang from '../../../../lang/translator';
  import isEmpty from 'lodash/isEmpty';
  import isObject from 'lodash/isObject';
  import cloneDeep from 'lodash/cloneDeep';
  import curator from '../../api/curator';
  import Loader from '../../../loader/components/Loader';
  import axios from 'axios';

  export default {
    name: 'CuratorModal',
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'data': {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        user: {
          username: null,
          displayName: null,
          password: null,
          passwordConfirmation: null
        },
        oldUser: {},
        isLoaded: true,
        disabled: false,
        userName: lang.get('user.username'),
        passwordLabel: lang.get('validation.attributes.password'),
      };
    },
    async created() {
      Validator.extend('unique_username', {
        getMessage: attribute => lang.get('validation.unique',
                {attribute}),
        validate: async(username) => {
          let valid;
          let userId;
          if (this.isEdit) {
            if (username === this.oldUser.username) {
              return true;
            } else {
              userId = this.user.id
            }
          }
          try {
            let {data: response} = await axios.post(
              '/registration/validate-username', {username, userId});
            valid = response.data.valid;
          } catch (e) {
            valid = false;
          }
          return {valid};
        },
      });
    },
    components: {
      Loader
    },
    methods: {
      ...mapActions('curator/repository', [
        'editItem',
        'addItem',
      ]),
      async save() {
        this.disabled = true;
        let result = await this.$validator.validateAll();
        if (!result) {
          this.disabled = false;
          return;
        }

        try {
          let method = this.isEdit
              ? this.editItem
              : this.addItem;

          method(this.user);

          //this.close();
        } catch (e) {
        } finally {
          this.disabled = false;
          this.isloading = true;
        }
      },
      reset() {
        console.log(this.$data);
        Object.assign(this.$data, this.$options.data());
        this.errors.clear();
      },
      close() {
        this.$emit('close');
        this.reset();
      },
    },
    computed: {
      isEdit() {
        return !isEmpty(this.data);
      },
      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        },
      },
      ...mapState('curator/repository', [
        'validationError',
        'isChanged'
      ]),
    },
    watch: {
      async visible(newValue, oldValue) {
        if (this.isEdit) {
          if (this.data.item && isObject(this.data.item)) {
            try {
              this.isLoaded = false;
              let response = await curator.findById({id: this.data.item.id});
              this.user = response.data.data;
              this.oldUser = cloneDeep(this.data.item);
            } catch (e) {
              console.error('Unknown API error occurred.');
            } finally {
              this.isLoaded = true;
            }
          }
        }
      },
      async validationError(newValue) {
        if(newValue){
          this.errors.add({
            field: 'isValidationError',
            msg: newValue.message
          });
        } else{
          this.errors.clear()
        }
      },
      async isChanged(newValue) {
        if(newValue){
          this.close();
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/user/curator/components/Modal.vue